module.exports = __webpack_public_path__ + "static/media/dblog1.94990e06.jpg";